import { API, Auth } from 'aws-amplify'

function isSubFormValid (regForm) {
  return true
}

async function createSubscription (regForm) {
  const result = {
    user: null,
    hasError: false,
    error: null
  }
  console.log('Validating Subscription Form...')
  if (!isSubFormValid(regForm)) {
    console.log('*** INVALID ***')
    result.hasError = true
    result.error = 'There is an Error in Your Registration Form'
    return result
  }

  console.log('Submitting Registration Request...')
  let myInit = {
    response: false,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    },
    body: {
      registration: regForm
    }
  }

  console.log(myInit)
  return API.post('mctcuser', '/subscription', myInit)
}

async function getMemberProfile () {
  let profileId = (await Auth.currentUserInfo()).username
  let myInit = {
    response: false,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    }
  }

  return API.get('mctcuser', `/users/${profileId}`, myInit)
}

async function updateMemberProfile (data) {
  let profileId = (await Auth.currentUserInfo()).username
  let myInit = {
    response: false,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    },
    body: {
      updatedProfile: data
    }
  }

  return API.post('mctcuser', `/users/${profileId}`, myInit)
}

async function getUserCertificate () {
  let profileId = (await Auth.currentUserInfo()).username
  let myInit = {
    response: false,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    }
  }

  return API.get('mctcuser', `/users/${profileId}/certificate`, myInit)
}

export default {
  createSubscription,
  getMemberProfile,
  updateMemberProfile,
  getUserCertificate
}
